import "./Footer.scss";

export default {
  root: "im-footer",
  body: "im-footer__body",
  content: "im-footer__content",
  partnersMain: "im-footer__partners-main",
  brand: "im-footer__brand",
  brandText: "im-footer__brand-text",
  partnersSub: "im-footer__partners-sub",
  logo: "im-footer__logo",
};
